import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';
import { ModalComponent } from '../../shared/modal/modal.component';
import { redirectToUrl } from '../utils/navigation.utils';
import {
  CLUB_URL,
  CLUBE_HOTELS,
  CLUBE_ASSISTANCE,
  CLUBE_CARS,
  CLUBE_WANT_MEMBER
} from '../utils/urls.constants';

interface ClubBenefit {
  icon: string;
  iconGris: string;
  lockAlt: string;
  title: string;
  titleGris: string;
  subtitle: string;
  discount: string;
  clickHandler: () => void;
}

@Component({
  selector: 'al-club-benefits',
  standalone: true,
  imports: [CommonModule, AssetsUrlPipe],
  templateUrl: './club-benefits.component.html',
  styleUrls: ['./club-benefits.component.scss']
})
export class ClubBenefitsComponent {
  @Input() isClube = false;
  @Input() source = '';

  upaAsyncService = inject(UpaAsyncService);


  onClubIfoodClick() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'sou_clube_ifood',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(CLUB_URL);
  }

  onClubeHotelsClick(): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'clube_hoteis',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(CLUBE_HOTELS);
  }

  onClubeAssistanceClick(): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'clube_seguro',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(CLUBE_ASSISTANCE);
  }

  onClubeCarsClick(): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'clube_carros',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(CLUBE_CARS);
  }

  onClubeWantMemberClick(): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'clube_quero_ser',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(CLUBE_WANT_MEMBER);
  }

  public clubBenefits: ClubBenefit[] = [
    {
      icon: 'images/ifood-landing/hotel.svg',
      iconGris: 'images/ifood-landing/hotel-gris.svg',
      lockAlt: 'Hotéis bloqueados',
      title: '25% off',
      titleGris: '25% off',
      subtitle: 'em hotéis selecionados',
      discount: '25%',
      clickHandler: () => this.onClubeHotelsClick()
    },
    {
      icon: 'images/ifood-landing/assis.svg',
      iconGris: 'images/ifood-landing/assis-gris.svg',
      lockAlt: 'Seguro bloqueados',
      title: '25% off',
      titleGris: '25% off',
      subtitle: 'em seguro viagem',
      discount: '25%',
      clickHandler: () => this.onClubeAssistanceClick()
    },
    {
      icon: 'images/ifood-landing/car.svg',
      iconGris: 'images/ifood-landing/car-gris.svg',
      lockAlt: 'Carros bloqueados',
      title: '15% off',
      titleGris: '15% off',
      subtitle: 'em aluguel de carros nos EUA',
      discount: '15%',
      clickHandler: () => this.onClubeCarsClick()
    }
  ];

}
